(ns app.front.view.group.admin.fees.formula.formula-events
  (:require [clojure.string :as str]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-db ::change-test-variable
  (fn [db [_ entity-id field variable value]]
    (assoc-in db [::formula :test entity-id field :values variable] value)))


(rf/reg-event-fx ::evaluate-test
  (fn [{:keys [db]} [_ entity-id field formula test-values]]
    (let [expression (reduce (fn [expr [var val]]
                               (str/replace expr var (str val)))
                             (:formula formula)
                             test-values)]
      {:db           (assoc-in db [::formula :test entity-id field :expression] expression)
       :comm/command {:command    :fee/evaluate-expression
                      :method     :post
                      :data       {:expression expression}
                      :on-success [::test-evaluated entity-id field]}})))


(rf/reg-event-db ::test-evaluated
  (fn [db [_ entity-id field _ response]]
    (assoc-in db [::formula :test entity-id field :result] (:result response))))
